import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import localStorageReducer from './localStorage';
import dictionaryReducer from './dictionary';
import statisticsReducer from './statistics';
import squadReducer from './squad';
import clubInfoReducer from './clubInfo';
import headerInfoReducer from './headerInfo';
import lineupsReducer from './lineups';
import probabiliReducer from './probabili';
import teamCalendarReducer from './calendar';

const reducers = {
  localStorageReducer,
  dictionaryReducer,
  statisticsReducer,
  squadReducer,
  clubInfoReducer,
  headerInfoReducer,
  lineupsReducer,
  probabiliReducer,
  teamCalendarReducer,
};

const rootReducer = history => combineReducers({
  router: connectRouter(history),
  ...reducers,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/demo/reducers/index.js